import React from 'react';

import {Bling as GPT} from "react-gpt";
//import Ads from "../../ad-config";

GPT.enableSingleRequest();
//import ReactHtmlParser from 'react-html-parser';
//Gpt.enableSingleRequest();
export default class Ros_bottom_center_728_90 extends React.Component {
        render() {
            let Ads = this.props.AdData;
            return (
    <>
    {(() => {
         if (Object.keys(Ads).length> 0 ) {
           return (
            <GPT 
                adUnitPath={Ads.adunitPath_rosBottomCenter72890}
                name={Ads.name_rosBottomCenter72890}
                 slotSize={[728, 90]}
    />
           )
         } 
       })()}
   </>
            )
        }
    }